import CadastroContainer from "../../components/CadastroContainer/CadastroContainer";
import { RiEye2Line } from "react-icons/ri";
import Button from "../../components/Button/Button";
import { TbBuildingCommunity } from "react-icons/tb";
import { publish } from "../../utils/events";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../contexts/userStore";

export function NoLicense({ isRootUnit = false, ...props }) {
   const navigate = useNavigate();
   const {
      selectedCondominioObj,
      selectingUnit,
      selectedLicenceObj
   } = useUserStore();

   return (
      <CadastroContainer>
         <div className="flex items-center gap-2.5 text-(--textColor)">
            <div className="p-0! [&>svg]:w-[1.3rem]! rounded-[8px] flex justify-center items-center">
               <RiEye2Line size={23} />
            </div>
            <h1 className="search-container-title m-0!">Monitoramento {selectedCondominioObj.name}</h1>
         </div>
         <div className="mt-5! text-(--textColor) opacity-70 text-base!">
            {isRootUnit ? (
               <>
                  A unidade raiz <strong>{selectedCondominioObj.name}</strong> não possui licença vinculada, selecione uma unidade com licença vinculada para o monitoramento.
               </>
            ) : (
               <>
                  A unidade <strong>{selectedCondominioObj.name}</strong> não possui licença vinculada, selecione uma unidade com licença vinculada para o monitoramento.
               </>
            )}
         </div>
         <div className="flex gap-2 flex-row items-center mt-4!">
            <Button
               className={"button-blue m-0!"}
               label={"Selecionar licença"}
               onClick={() => {
                  publish('onSelectLicenseRequest', true);
               }}
               icon={<TbBuildingCommunity size={17} />}
            />
            <Button
               className={"button-white"}
               label={"Ver unidades"}
               onClick={() => navigate(`/consulta-condominios`)}
            />
         </div>
      </CadastroContainer>
   );
}